module.exports = __webpack_public_path__ + "static/media/NokiaPureTWeb_Bd.d3eadc8d.ttf";